import { render, staticRenderFns } from "./uploadfarmercompany.vue?vue&type=template&id=cdc5936c"
import script from "./uploadfarmercompany.vue?vue&type=script&lang=js"
export * from "./uploadfarmercompany.vue?vue&type=script&lang=js"
import style0 from "./uploadfarmercompany.vue?vue&type=style&index=0&id=cdc5936c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports